/**
 * Product import from CSV. CSV column names are the user's own data and
 * are never translated; `fields` are the product fields they map onto
 * (the server sends English labels, keyed by these same keys).
 */
export default {
    title: 'Import products',
    fixErrors: 'Please fix the highlighted fields.',
    upload: {
        title: 'Upload a CSV',
        intro: 'Export from WooCommerce, Shopify, or any platform that emits a CSV. Variant rows are flattened: each row becomes one product, keyed by SKU.',
        reimport: 'Re-importing the same SKU updates the existing product.',
        categories: 'Missing categories are created automatically (unpublished).',
        images: 'Image URLs are downloaded into your media library.',
        cleanup: 'The CSV is deleted after the job finishes.',
        choose: 'Choose CSV…',
    },
    map: {
        title: 'Map columns',
        intro: "Match each product field to a column in your CSV. We've pre-filled guesses based on common export formats; adjust as needed. Required fields are marked with *.",
        productField: 'Product field',
        csvColumn: 'CSV column',
        sampleValue: 'Sample value',
        skip: '(skip)',
        weightUnit: 'Weight column is in {unit}',
        grams: 'grams',
        kilograms: 'kilograms',
        preview: 'Preview first row | Preview first {n} rows',
        start: 'Start import',
    },
    fields: {
        name: 'Name',
        sku: 'SKU',
        priceCents: 'Price',
        brand: 'Brand',
        gtin: 'Barcode (EAN / GTIN)',
        shortDescription: 'Short description',
        description: 'Description',
        stock: 'Stock',
        trackStock: 'Track stock',
        weightGrams: 'Weight',
        categories: 'Categories',
        tags: 'Tags',
        images: 'Images',
        published: 'Published',
        featured: 'Featured',
    },
    progress: {
        title: 'Importing…',
        rows: '{processed} of {total} rows ({ok} ok, {failed} failed)',
    },
    done: {
        complete: 'Import complete',
        finished: 'Import finished',
        finishedWithErrors: 'Import finished with errors',
        imported: 'Imported',
        failed: 'Failed',
        rowsFailed: '{n} row could not be imported. | {n} rows could not be imported.',
        rowError: 'Row {row}: {message}',
        downloadErrors: 'Download full error CSV',
        another: 'Import another',
        backToProducts: 'Back to products',
    },
    status: {
        queued: 'Queued',
        running: 'Running',
        complete: 'Complete',
        failed: 'Failed',
    },
};
